



































import Vue from 'vue';
// import { mapGetters, mapActions } from 'vuex'
import defaulter from '@/modules/defaulter'
import phonenumber from '@/modules/phonenumber'

export default Vue.extend({
  name: 'BankModal',
  data () {
    return {
      modal: {
        title: "Bank",
        okOnly: false,
        okAction: null
      },
      emptyBankForm: {
        id: null,
        name: '',
        phone_number: null
      },
      bankForm: {
        id: null,
        name: '',
        phone_number: null
      },
      feedbackMessage: '',
      showingConfirmDeleteButton: false
    }
  },
  methods: {

    handleModalOk (bvModalEvent) {
      bvModalEvent.preventDefault()
      this.submitForm()
    },

    show (bank?: Bank) {
      if (bank) {
        this.bankForm = defaulter.merge(this.emptyBankForm, bank)
      }
      this.feedbackMessage = ''
      this.$refs.modal.show()
    },

    hide () {
      this.$refs.modal.hide()
    },

    async submitForm () {
      console.log('BankModal.submitForm', this.bankForm)
      if (!this.bankForm.name) {
        this.$refs.nameInput.focus()
        return
      }
      if (!this.bankForm.phone_number) {
        this.$refs.phoneNumberInput.focus()
        return
      }
      const result = await this.$store.dispatch('addOrUpdateBank', this.bankForm)
      console.log('  result', result)
      this.feedbackMessage = result.message
      if (result.success) {
        this.$emit('change')
        setTimeout(() => {
          this.hide();
        }, 1000)
      }
    },

    confirmDeleteBank () {
      this.showingConfirmDeleteButton = true
    },

    async deleteBank () {
      console.log('BankModal.deleteBank', this.bankForm)
      const result = await this.$store.dispatch('deleteBank', this.bankForm)
      console.log('  result', result)
      this.feedbackMessage = result.message
      if (result.success) {
        this.$emit('change')
        setTimeout(() => {
          this.hide();
        }, 1000)
      }
    },

    parsePhoneNumber (phone, event) {
      let parsed = phonenumber.parsePhoneNumber(phone)
      this.$set(this.bankForm, 'phone_number', parsed.formatted)
      event.target.focus();
      event.target.setSelectionRange(parsed.formatted.length, parsed.formatted.length);
    },

  }
})
